import React from "react";
import { RouteComponentProps } from "react-router";
import { TimereportKitFlowSearch } from "./TimereportKitFlowSearch";
import { checkIfDirectRoute } from "@utils/navigationUtils";
import { store } from "@store";
import { BOOKING_SLIDER, BookingEditLocation, BookingProfileLocation } from "@navigation";
import { TravelConfirmationViewLocation } from "@bookings/BookingHospitality/locations/TravelConfirmationViewLocation";
import { AccommodationConfirmationViewLocation } from "@bookings/BookingHospitality/locations/AccommodationConfirmationViewLocation";

type Props = RouteComponentProps<any> & {};

export function TimereportKitFlowSearchPage(props: Props) {
  const { url } = props.match;
  const { navigation } = store();
  return (
    <>
      {catchDirectUrl(url)}
      <TimereportKitFlowSearch
        onOpen={(id) => navigation.open(BOOKING_SLIDER, new BookingProfileLocation(id))}
        onEdit={(id) => {
          return navigation.open(BOOKING_SLIDER, new BookingEditLocation(id));
        }}
      />
    </>
  );
}

function catchDirectUrl(url) {
  return checkIfDirectRoute(
    `${url}/:bookingId?/:tab?/:subId?`,
    BOOKING_SLIDER,
    ({ action1, bookingId, tab, subId }) => {
      const action = action1 || "view";
      const realId = bookingId !== "new" ? bookingId : null;

      if (tab === "accommodation-confirmation") {
        return new AccommodationConfirmationViewLocation({
          bookingId,
          confirmationId: subId
        });
      }

      if (tab === "travel-confirmation") {
        return new TravelConfirmationViewLocation({ bookingId, confirmationId: subId });
      }

      if (bookingId === "new" || (bookingId && action === "edit")) {
        return new BookingEditLocation(realId);
      }

      if (bookingId && action === "view") {
        return new BookingProfileLocation(realId, tab);
      }
    }
  );
}
